import { render, staticRenderFns } from "./EditorWalletCard.vue?vue&type=template&id=f7e32262&scoped=true&"
import script from "./EditorWalletCard.vue?vue&type=script&lang=js&"
export * from "./EditorWalletCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e32262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7e32262')) {
      api.createRecord('f7e32262', component.options)
    } else {
      api.reload('f7e32262', component.options)
    }
    module.hot.accept("./EditorWalletCard.vue?vue&type=template&id=f7e32262&scoped=true&", function () {
      api.rerender('f7e32262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorWalletCard.vue"
export default component.exports